import { render, staticRenderFns } from "./contract-popover.vue?vue&type=template&id=2c115966&scoped=true"
import script from "./contract-popover.vue?vue&type=script&lang=js"
export * from "./contract-popover.vue?vue&type=script&lang=js"
import style0 from "./contract-popover.vue?vue&type=style&index=0&id=2c115966&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c115966",
  null
  
)

export default component.exports